<template>
  <div class="swiper-container" ref="swiperEl">
    <div class="swiper-wrapper">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="swiper-slide"
      >
        <picture>
          <source
            :srcset="isMobile ? `/images/${slide.mobileWebp}` : `/images/${slide.desktopWebp}`"
            type="image/webp"
          >
          <img
            :src="isMobile ? `/images/${slide.mobileJpg}` : `/images/${slide.desktopJpg}`"
            :alt="slide.alt"
            :loading="index === 0 ? 'eager' : 'lazy'"
            :fetchpriority="index === 0 ? 'high' : 'auto'"
            width="1920"
            height="850"
          >
        </picture>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'SwiperSlider',
  data() {
    return {
      isMobile: false,
      swiper: null,
      slides: [
        {
          desktopWebp: 'fachada_pagina.webp',
          desktopJpg:  'fachada_pagina.jpg',
          mobileWebp:  'fachada_pagina_mobile.webp',
          mobileJpg:   'fachada_pagina_mobile.jpg',
          alt: 'Fachada Grupo Babilonia'
        },
        {
          desktopWebp: 'los_descreidos_muerte_1.webp',
          desktopJpg:  'los_descreidos_muerte_1.jpeg',
          mobileWebp:  'los_descreidos_muerte_1_mobile.webp',
          mobileJpg:   'los_descreidos_muerte_1_mobile.jpeg',
          alt: 'Los Descreídos — Grupo Babilonia'
        },
        {
          desktopWebp: 'Grupo_Scaled.webp',
          desktopJpg:  'Grupo_Scaled.JPG',
          mobileWebp:  'Grupo_Scaled_mobile.webp',
          mobileJpg:   'Grupo_Scaled_mobile.JPG',
          alt: 'Grupo Babilonia'
        },
        {
          desktopWebp: 'Yuri_Playa.webp',
          desktopJpg:  'Yuri_Playa.JPG',
          mobileWebp:  'Yuri_Playa_mobile.webp',
          mobileJpg:   'Yuri_Playa_mobile.JPG',
          alt: 'Yuri Playa — Grupo Babilonia'
        },
        {
          desktopWebp: 'Babilonia_Circo_1.webp',
          desktopJpg:  'Babilonia_Circo_1.jpeg',
          mobileWebp:  'Babilonia_Circo_1_mobile.webp',
          mobileJpg:   'Babilonia_Circo_1_mobile.jpeg',
          alt: 'Babilonia Circo — Grupo Babilonia'
        },
        {
          desktopWebp: 'Circo_Scaled.webp',
          desktopJpg:  'Circo_Scaled.jpg',
          mobileWebp:  'Circo_Scaled_mobile.webp',
          mobileJpg:   'Circo_Scaled_mobile.jpg',
          alt: 'Circo — Grupo Babilonia'
        },
      ]
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.$nextTick(() => {
      this.swiper = new Swiper(this.$refs.swiperEl, {
        modules: [Autoplay, Pagination],
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        speed: 600,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      })
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
    if (this.swiper) this.swiper.destroy()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    }
  }
}
</script>

<style scoped>
.swiper-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/* Dark gradient overlay at top for nav visibility */
.swiper-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 250px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.2) 70%, transparent 100%);
  z-index: 10;
  pointer-events: none;
}

.swiper-slide img {
  width: 100%;
  height: auto;
  display: block;
}

/* Pagination dots — right side on desktop */
:deep(.swiper-pagination) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 20px !important;
  top: 50%;
  bottom: auto !important;
  right: 20px !important;
  left: auto !important;
  transform: translateY(-50%);
}

:deep(.swiper-pagination-bullet) {
  width: 12px;
  height: 12px;
  background: #ccc;
  opacity: 1;
  margin: 0 !important;
  transition: background 0.3s;
}

:deep(.swiper-pagination-bullet-active) {
  background: #fff;
}

/* Mobile */
@media (max-width: 768px) {
  .swiper-container,
  .swiper-slide {
    height: 55vh;
  }

  .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  :deep(.swiper-pagination) {
    display: none;
  }
}
</style>
